import { style } from '@vanilla-extract/css'

const label = style({
  fontFamily: 'Inter Variable, sans-serif',
  fontWeight: '700',
  fontSize: '13px',
  color: '#828282',
})

export const styles = { label }
